/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quality: "average" | "bad" | "good" | "perfect" | "very-bad" | "worse" }} Air_Quality_ValuesInputs */



/**
* | quality | output |
* | --- | --- |
* | "average" | "Average" |
* | "bad" | "Poor" |
* | "good" | "Good" |
* | "perfect" | "Excellent" |
* | "very-bad" | "Very poor" |
* | "worse" | "Degraded" |
*
* @param {Air_Quality_ValuesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_quality_values = /** @type {((inputs: Air_Quality_ValuesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Quality_ValuesInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.quality === "average") return /** @type {LocalizedString} */ (`Average`);
		if (i?.quality === "bad") return /** @type {LocalizedString} */ (`Poor`);
		if (i?.quality === "good") return /** @type {LocalizedString} */ (`Good`);
		if (i?.quality === "perfect") return /** @type {LocalizedString} */ (`Excellent`);
		if (i?.quality === "very-bad") return /** @type {LocalizedString} */ (`Very poor`);
		if (i?.quality === "worse") return /** @type {LocalizedString} */ (`Degraded`);
		return /** @type {LocalizedString} */ ("air_quality_values");
	}
	{
		if (i?.quality === "average") return /** @type {LocalizedString} */ (`Moyenne`);
		if (i?.quality === "bad") return /** @type {LocalizedString} */ (`Mauvaise`);
		if (i?.quality === "good") return /** @type {LocalizedString} */ (`Bonne`);
		if (i?.quality === "perfect") return /** @type {LocalizedString} */ (`Excellente`);
		if (i?.quality === "very-bad") return /** @type {LocalizedString} */ (`Très mauvaise`);
		if (i?.quality === "worse") return /** @type {LocalizedString} */ (`Dégradée`);
		return /** @type {LocalizedString} */ ("air_quality_values");
	}
});